require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.3@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 264
// module chunks = 0